'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PricingButtonContainer = exports.PricingFeature = exports.PricingTableBody = exports.PricingTablePrice = exports.PricingTableHeader = exports.PricingTable = exports.default = undefined;

var _extends2 = require('@babel/runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('core-js/modules/es6.object.get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('@babel/runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('@babel/runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('@babel/runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('@babel/runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Col = require('./Col');

var _Col2 = _interopRequireDefault(_Col);

var _Row = require('./Row');

var _Row2 = _interopRequireDefault(_Row);

var _Grid = require('./Grid');

var _Grid2 = _interopRequireDefault(_Grid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PricingTableContainer = function (_React$Component) {
  (0, _inherits3.default)(PricingTableContainer, _React$Component);

  function PricingTableContainer() {
    (0, _classCallCheck3.default)(this, PricingTableContainer);
    return (0, _possibleConstructorReturn3.default)(this, (PricingTableContainer.__proto__ || (0, _getPrototypeOf2.default)(PricingTableContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(PricingTableContainer, [{
    key: 'render',
    value: function render() {
      var props = (0, _extends3.default)({}, this.props, {
        className: (0, _classnames2.default)('container-sm-height', this.props.className)
      });

      return _react2.default.createElement(
        _Grid2.default,
        props,
        _react2.default.createElement(
          _Row2.default,
          { className: 'row-sm-height' },
          this.props.children
        )
      );
    }
  }]);
  return PricingTableContainer;
}(_react2.default.Component);

exports.default = PricingTableContainer;
var PricingTable = exports.PricingTable = (_temp = _class = function (_React$Component2) {
  (0, _inherits3.default)(PricingTable, _React$Component2);

  function PricingTable() {
    (0, _classCallCheck3.default)(this, PricingTable);
    return (0, _possibleConstructorReturn3.default)(this, (PricingTable.__proto__ || (0, _getPrototypeOf2.default)(PricingTable)).apply(this, arguments));
  }

  (0, _createClass3.default)(PricingTable, [{
    key: 'render',
    value: function render() {
      var classes = (0, _classnames2.default)({
        'col-sm-height': true,
        'pricing-table': true,
        'preferred': this.props.preferred
      });

      var props = (0, _extends3.default)({
        xs: 12
      }, this.props, {
        className: classes.trim()
      });

      delete props.preferred;

      return _react2.default.createElement(
        _Col2.default,
        props,
        this.props.children
      );
    }
  }]);
  return PricingTable;
}(_react2.default.Component), _class.propTypes = {
}, _temp);

var PricingTableHeader = exports.PricingTableHeader = function (_React$Component3) {
  (0, _inherits3.default)(PricingTableHeader, _React$Component3);

  function PricingTableHeader() {
    (0, _classCallCheck3.default)(this, PricingTableHeader);
    return (0, _possibleConstructorReturn3.default)(this, (PricingTableHeader.__proto__ || (0, _getPrototypeOf2.default)(PricingTableHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(PricingTableHeader, [{
    key: 'render',
    value: function render() {
      var props = (0, _extends3.default)({}, this.props, {
        className: (0, _classnames2.default)('pricing-table-header text-center text-uppercase', this.props.className)
      });

      return _react2.default.createElement(
        'div',
        props,
        _react2.default.createElement(
          'h3',
          null,
          this.props.children
        )
      );
    }
  }]);
  return PricingTableHeader;
}(_react2.default.Component);

var PricingTablePrice = exports.PricingTablePrice = function (_React$Component4) {
  (0, _inherits3.default)(PricingTablePrice, _React$Component4);

  function PricingTablePrice() {
    (0, _classCallCheck3.default)(this, PricingTablePrice);
    return (0, _possibleConstructorReturn3.default)(this, (PricingTablePrice.__proto__ || (0, _getPrototypeOf2.default)(PricingTablePrice)).apply(this, arguments));
  }

  (0, _createClass3.default)(PricingTablePrice, [{
    key: 'render',
    value: function render() {
      var props = (0, _extends3.default)({}, this.props, {
        className: (0, _classnames2.default)('pricing-table-price text-center text-uppercase', this.props.className)
      });

      return _react2.default.createElement(
        'div',
        props,
        _react2.default.createElement(
          'h2',
          null,
          this.props.children
        )
      );
    }
  }]);
  return PricingTablePrice;
}(_react2.default.Component);

var PricingTableBody = exports.PricingTableBody = function (_React$Component5) {
  (0, _inherits3.default)(PricingTableBody, _React$Component5);

  function PricingTableBody() {
    (0, _classCallCheck3.default)(this, PricingTableBody);
    return (0, _possibleConstructorReturn3.default)(this, (PricingTableBody.__proto__ || (0, _getPrototypeOf2.default)(PricingTableBody)).apply(this, arguments));
  }

  (0, _createClass3.default)(PricingTableBody, [{
    key: 'render',
    value: function render() {
      var props = (0, _extends3.default)({}, this.props, {
        className: (0, _classnames2.default)('pricing-table-body text-center', this.props.className)
      });

      return _react2.default.createElement(
        'div',
        props,
        this.props.children
      );
    }
  }]);
  return PricingTableBody;
}(_react2.default.Component);

var PricingFeature = exports.PricingFeature = function (_React$Component6) {
  (0, _inherits3.default)(PricingFeature, _React$Component6);

  function PricingFeature() {
    (0, _classCallCheck3.default)(this, PricingFeature);
    return (0, _possibleConstructorReturn3.default)(this, (PricingFeature.__proto__ || (0, _getPrototypeOf2.default)(PricingFeature)).apply(this, arguments));
  }

  (0, _createClass3.default)(PricingFeature, [{
    key: 'render',
    value: function render() {
      var props = (0, _extends3.default)({}, this.props, {
        className: (0, _classnames2.default)('pricing-table-feature text-center', this.props.className)
      });

      return _react2.default.createElement(
        'div',
        props,
        this.props.children
      );
    }
  }]);
  return PricingFeature;
}(_react2.default.Component);

var PricingButtonContainer = exports.PricingButtonContainer = function (_React$Component7) {
  (0, _inherits3.default)(PricingButtonContainer, _React$Component7);

  function PricingButtonContainer() {
    (0, _classCallCheck3.default)(this, PricingButtonContainer);
    return (0, _possibleConstructorReturn3.default)(this, (PricingButtonContainer.__proto__ || (0, _getPrototypeOf2.default)(PricingButtonContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(PricingButtonContainer, [{
    key: 'render',
    value: function render() {
      var props = (0, _extends3.default)({}, this.props, {
        className: (0, _classnames2.default)('pricing-btn-container text-center', this.props.className)
      });

      return _react2.default.createElement(
        'div',
        props,
        this.props.children
      );
    }
  }]);
  return PricingButtonContainer;
}(_react2.default.Component);